import script from "./campusHire.vue?vue&type=script&setup=true&lang=js"
export * from "./campusHire.vue?vue&type=script&setup=true&lang=js"

import "./campusHire.vue?vue&type=style&index=0&id=0e72a66d&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e72a66d"]])

export default __exports__